import { createSlice } from "@reduxjs/toolkit";
const chapterReportSlice = createSlice({
  name: "chapterReport",

  //initial state
  initialState: {
    shareReport: {},
    sharePayload: {},
  },

  //reducer
  reducers: {
    setChapterShareReportDetails: (state, action) => {
      state.shareReport = action.payload;
    },
    setChapterSharePayload: (state, action) => {
      state.sharePayload = action.payload;
    },
  },
});

export default chapterReportSlice.reducer;
export const { setChapterShareReportDetails, setChapterSharePayload } =
  chapterReportSlice.actions;
export const selectChapterShareReport = (state) =>
  state.chapterReport.shareReport;
export const selectChapterSharePayload = (state) =>
  state.chapterReport.sharePayload;
